import React, { useContext, useEffect, useMemo, useRef } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import FieldProperties from "./FieldProperties";
import DataValidation from "./DataValidation";
import { Box, Tabs, Tab } from "@mui/material";
import TabPanel from "../TabPanel";
import { useState } from "react";
import BallotOutlinedIcon from "@mui/icons-material/BallotOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import { useSelector } from "react-redux";
import CommentProperties from "./CommentProperties";
import RecordPropertyForm from "./Forms/RecordPropertyForm";
import datatypes, { ELEMENT_TYPE, FIELD_TYPE, RECORD_TYPE,OTHER_TYPE } from "../../constants/datatypes";
import FieldPropertyForm from "./Forms/FieldPropertyForm";
import DatabaseForm from "./Forms/DatabaseForm";
import ObjectProperties from "./Forms/DataTypeComponents/JsonObjectProperties";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import FieldGroupProperties from "./Forms/FieldGroupProperties";
import { lgDocPath } from "../../constants/languageDocPaths";
export default function ItemPropertiesContainer(props) {
  const { t } = useTranslation();
  const [currTab, setCurrTab] = useState(0);
  const parentScreen = useContext(ParentScreenCtx);
  const queryParams = useSelector(state => state.queryParams);
  const { rightTree, leftTree } = useSelector((state) => state.treeData[parentScreen]);
  const currentTab = rightTree.currentTab;
  const selectedNode = rightTree.tree[currentTab].selectedNode;
  // const {type ,TYPE,ICON_DISPLAY} = selectedNode;
  const type = selectedNode?.type;
  const ICON_DISPLAY = selectedNode?.ICON_DISPLAY;
  const templateHeader = rightTree.tree.templateHeader;
  const itemContainerRef = useRef();
  const docRef = useRef();
  const timestamp = Date.now();

  const handleTabChange = (event, newValue) => {
    setCurrTab(newValue);
  };
  
  useEffect(()=>{
    setCurrTab(0);
    itemContainerRef.current?.scroll({top:0,behaviour:'smooth'}); //Container Should scroll to top.
  },[selectedNode?.key])

  // point to appropriate docs path, or use 'en' default.
  // Added useMemo because it is reloading middle panel again and again on every action at template properties
  const docPath = useMemo(() => `${queryParams.baseUrl}/docs/${lgDocPath[queryParams.lang] || 'en'}/Workbench/screens/${parentScreen}/index.html?timestamp=${timestamp}`, [leftTree?.tree?.body?.selectedNode?.key, queryParams, parentScreen])

  const iframeOnLoad = (event) => {
    // console.log(event);
    // console.log(docPath);
    // console.log(docRef);

    //TODO: if path is not found, an error status is displayed. We need a way to detect this so that a 
    // fetch error page does not show for user when the iframe is 404.
  }

  return (
    <div className="height-100 width-100" id="docContainer">
      {ICON_DISPLAY === "COMMENT" && (
        <>
          <Box className="divider-bottom">
            <Tabs value={currTab} onChange={handleTabChange}>
              <Tab
                label={
                  <div className="flex align-center">
                    <BallotOutlinedIcon
                      size="small"
                      className="margin-right-4"
                    />
                    {t("LBL_COMMENT_PROP")}
                  </div>
                }
              />
            </Tabs>
          </Box>
          <Box className="height-100-tab overflow-auto">
            <TabPanel style={{ minWidth: "150px" }} value={currTab} index={0}>
              <CommentProperties />
            </TabPanel>
          </Box>
        </>
      )}
      {ICON_DISPLAY && ICON_DISPLAY !== "COMMENT" && ICON_DISPLAY !== 'TEMPLATE_BODY_DOTS' && (
        <>
          <Box className="divider-bottom">
            <Tabs value={currTab} onChange={handleTabChange}>
              {templateHeader.FILETYPE !== "XML" && (
                <Tab
                  label={
                    <div className="flex align-center">
                      <BallotOutlinedIcon
                        size="small"
                        className="margin-right-4"
                      />
                      {/* {FIELD_TYPE[ICON_DISPLAY] ? t("LBL_FLD_PROP") : t('LBL_REC_PROP')} */}
                      {/* { FIELD_TYPE[ICON_DISPLAY] ? t("LBL_FLD_PROP") : templateHeader.FILETYPE === "JSON"  ? t('LBL_OBJECT_PROPERTIES') :t('LBL_REC_PROP') } */}
                      {FIELD_TYPE[ICON_DISPLAY]
                        ? t("LBL_FLD_PROP")
                        : templateHeader.FILETYPE === "JSON"
                        ? t("LBL_OBJECT_PROPERTIES")
                        : OTHER_TYPE[ICON_DISPLAY]
                        ? t("LBL_FLD_GRP_PROP")
                        : t("LBL_REC_PROP")}
                    </div>
                  }
                />
              )}

              {templateHeader.FILETYPE === "XML" && (
                <Tab
                  label={
                    <div className="flex align-center">
                      <BallotOutlinedIcon
                        size="small"
                        className="margin-right-4"
                      />
                      {(ELEMENT_TYPE[ICON_DISPLAY] || ICON_DISPLAY === "REPEATING_ELEMENT")
                        ? t("LBL_ELEM_PROPERTIES")
                        : t("LBL_ATTRIBUTES")}
                    </div>
                  }
                />
              )}
              {((templateHeader.FILETYPE === "DATABASE" &&
                !FIELD_TYPE[ICON_DISPLAY]) ||
                (templateHeader.FILETYPE === "JSON" &&
                  FIELD_TYPE[ICON_DISPLAY]) ||
                !["DATABASE", "XML", "JSON"].includes(
                  templateHeader.FILETYPE
                )) && (
                  !(!["HL7","EDI"].includes(templateHeader?.FILETYPE)&& ICON_DISPLAY.includes("FIELD_GROUP")) && <Tab
                  label={
                    <div className="flex align-center">
                      <FactCheckOutlinedIcon
                        size="small"
                        className="margin-right-4"
                      />
                      {templateHeader.FILETYPE === "DATABASE"
                        ? t("LBL_SUB_QUERY")
                        : t("LBL_DATA_VALIDATION")}
                    </div>
                  }
                />
              )}
            </Tabs>
          </Box>
          <Box ref={itemContainerRef} className="height-100-tab overflow-auto">
            <TabPanel
              style={{ minWidth: "150px" }}
              className="padding-12"
              value={currTab}
              index={0}>
              {ICON_DISPLAY &&
                FIELD_TYPE[ICON_DISPLAY] &&
                !["XML"].includes(templateHeader.FILETYPE) && (
                  <FieldProperties />
                )}
              {ICON_DISPLAY &&
                RECORD_TYPE[ICON_DISPLAY] &&
                !["XML"].includes(templateHeader.FILETYPE) && (
                  <>
                    {ICON_DISPLAY === RECORD_TYPE.QUERY.icon && (
                      <DatabaseForm />
                    )}
                    {ICON_DISPLAY === RECORD_TYPE.RECORD.icon &&
                      templateHeader.FILETYPE !== "JSON" && (
                        /* Remount when selection changes so record-mapping state/debouncers cannot leak between nodes */
                        <RecordPropertyForm
                          key={`${currentTab}-${selectedNode?.key ?? ""}-${selectedNode?.nodeId ?? ""}`}
                        />
                      )}
                    {(ICON_DISPLAY === RECORD_TYPE.RECORD_TOP.icon ||
                      (ICON_DISPLAY === RECORD_TYPE.RECORD.icon &&
                        templateHeader.FILETYPE === "JSON")) && (
                      <ObjectProperties />
                    )}
                  </>
                )}
              {ICON_DISPLAY && ELEMENT_TYPE[ICON_DISPLAY] && (
                <FieldPropertyForm property="ELEMENT" />
              )}
              {ICON_DISPLAY && ICON_DISPLAY === "REPEATING_ELEMENT" && (
                <FieldPropertyForm property="ELEMENT" />
              )}
              {ICON_DISPLAY && ICON_DISPLAY === "ATTRIBUTE" && (
                <FieldPropertyForm property="ATTRIBUTE" />
              )}
              {ICON_DISPLAY && (ICON_DISPLAY === "FIELD_GROUP" || ICON_DISPLAY === 'REPEATING_FIELD_GROUP') && (
                <FieldGroupProperties></FieldGroupProperties>
              )}
            </TabPanel>
            <TabPanel style={{ minWidth: "150px" }} value={currTab} index={1}>
            <DataValidation 
                isVisible={ICON_DISPLAY !== "COMMENT" && currTab === 1}
              />
            </TabPanel>
          </Box>
        </>
      )}
      { (ICON_DISPLAY === "TEMPLATE_BODY_DOTS" || !ICON_DISPLAY) && ["inbound"].includes(parentScreen) && (
        <iframe
          className="docFrame"
          src={docPath}
          style={{ height: "calc(100% - 3px)", border: "unset" }}
          onLoad={iframeOnLoad}
          ref={docRef}
          ></iframe>
      )}
    </div>
  );
}

ItemPropertiesContainer.propTypes = {
  text: PropTypes.string,
};
